import { Directive, HostListener, Injector, Input, OnInit } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, NgControl, ValidationErrors, Validator } from '@angular/forms';

// Allows letters of any language (\p{L}), accent/combining marks (\p{M}), digits (\p{N}), space, underscore and hyphen
const ALLOWED_CHARACTERS_PATTERN = /^[\p{L}\p{M}\p{N} _-]*$/u;
const SPECIAL_CHARACTERS_MESSAGE = 'Special characters are not allowed. Allowed characters[hyphen(-), underscore(_), space()].';

@Directive({
    selector: '[appRequiredField]',
    providers: [{
            provide: NG_VALIDATORS,
            useExisting: RequiredFieldValidatorDirective,
            multi: true
        }],
    standalone: false
})
export class RequiredFieldValidatorDirective implements Validator, OnInit {

  @Input('appRequiredField') fieldName: string;
  @Input() restrictSpecialCharacters = false;

  private ngControl: NgControl;

  // NgControl can't be constructor-injected here: it needs all NG_VALIDATORS on
  // this element (including this directive), which causes a circular DI error (NG0200)
  constructor(private injector: Injector) { }

  ngOnInit(): void {
    this.ngControl = this.injector.get(NgControl);
  }

  validate(control: AbstractControl): ValidationErrors | null {

    if (control.value == null || control.value.length === 0) {
      return { message: `${this.fieldName} is required` };
    }

    if (this.restrictSpecialCharacters && !ALLOWED_CHARACTERS_PATTERN.test(control.value)) {
      return { message: SPECIAL_CHARACTERS_MESSAGE };
    }

    return null;

  }

  // Trim silently on blur instead of showing a leading/trailing whitespace error
  @HostListener('blur')
  onBlur(): void {
    const control = this.ngControl?.control;
    const value = control?.value;

    if (typeof value === 'string' && value !== value.trim()) {
      control.setValue(value.trim());
    }
  }

}


